import React from 'react';
import styles from './Select.module.css';

export default function Select({ label, value, onChange, options, isOptionDisabled }) {
    return (
        <label className={styles.field}>
            <select
                className={styles.input}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                {options.map((o) => {
                    const disabled = Boolean(o.disabled || (isOptionDisabled && isOptionDisabled(o)));
                    return (
                        <option
                            key={o.value}
                            value={o.value}
                            disabled={disabled}
                            aria-disabled={disabled}
                            className={disabled ? styles.optionDisabled : undefined}
                            title={disabled ? 'No results for this selection' : undefined}
                        >
                            {o.label}
                        </option>
                    );
                })}
            </select>
        </label>
    );
}
